export default "__VITE_ASSET__BcLK3hie__"